import axios from 'axios'
import { baseUrl } from '@/core/helpers'

export default {
  methods: {
    downloadTaskFile(task) {
      let url = `${baseUrl()}file/private/download?id=${task.task.file.id}`
      let label = `${task.task.file.name}.csv`
      return axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/audiences/mixins/fileDownloadMixin.js